import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWeightTrainingNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M30.3 16.785l-1.65 1.65a2.834 2.834 0 01-4.007 0l-3.13-3.13-6.209 6.208 3.13 3.13a2.833 2.833 0 010 4.008l-1.65 1.65a2.833 2.833 0 01-4.006 0l-.825-.825-1.492 1.491a2.833 2.833 0 01-4.007 0l-5.421-5.42a2.833 2.833 0 010-4.008l1.491-1.492-.825-.825a2.833 2.833 0 010-4.006l1.65-1.65a2.833 2.833 0 014.007 0l3.13 3.13 6.21-6.21-3.13-3.13a2.833 2.833 0 010-4.006l1.65-1.65a2.833 2.833 0 014.006 0l.825.825 1.492-1.492a2.833 2.833 0 014.007 0l5.421 5.421a2.834 2.834 0 010 4.007l-1.492 1.492.825.825a2.833 2.833 0 010 4.007zm-1.885-2.122l-2.767-2.767 1.052-.94a.252.252 0 00.008-.007l2.373-2.374a.167.167 0 000-.235l-5.42-5.421a.167.167 0 00-.237 0l-1.612 1.613 3.65 3.65-1.768 1.767-5.586-5.586.003-.003-.774-.775a.167.167 0 00-.236 0l-1.65 1.65a.167.167 0 000 .236l11.078 11.078c.065.065.17.065.236 0l1.65-1.65a.167.167 0 000-.236zm-9.952-2.408l-6.209 6.209 1.282 1.282 6.21-6.21zm-3.8 16.16c.065.065.17.065.236 0l1.65-1.65a.167.167 0 000-.236L5.47 15.451a.167.167 0 00-.236 0l-1.65 1.65a.167.167 0 000 .236l.9.9.003-.005 5.586 5.587-1.767 1.767-3.775-3.775-1.614 1.614a.167.167 0 000 .235l5.422 5.422c.065.065.17.065.235 0l2.374-2.374a.177.177 0 00.007-.008l.94-1.052z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWeightTrainingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWeightTrainingNormalMedium;
